import { connect } from "react-redux";

const Order = (props) => {
   const { carts } = props;
   return (
      <div className="list-cart-container">
         <div className="header-infor-address">
            <div className="title-container">
               <div className="svg-next-icon icon-title icon-location-fill">
               </div>
               <span className="title">Thông tin giao hàng</span>
            </div>
         </div>
         <div className="shipment-detail-order-confirm">
            <div>{carts.shipping_full_name} - {carts.shipping_phone}</div>
            <div className="address-info">
               {carts.shipping_address} - {carts.shipping_ward_name} - {carts.shipping_district_name} - {carts.shipping_province_name}
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
})(Order);